import React from 'react';
import { useStartupPrompt } from '@/contexts/StartupPromptContext';
import ConsentSheet from './ConsentSheet';
import UsernamePromptSheet from './UsernamePromptSheet';
import BiometricEnableModal from './BiometricEnableModal';
import StageTransitionSheet from './StageTransitionSheet';

export default function StartupPromptQueue() {
  const { currentPrompt, advanceQueue, pendingTransition, currentUserId } = useStartupPrompt();

  if (!currentPrompt) return null;

  return (
    <>
      {currentPrompt === 'consent' && <ConsentSheet />}
      {currentPrompt === 'username' && <UsernamePromptSheet />}
      {currentPrompt === 'biometric' && (
        <BiometricEnableModal
          queueVisible
          onQueueDismiss={advanceQueue}
          onQueueConfirm={advanceQueue}
        />
      )}
      {currentPrompt === 'stage_transition' && (
        <StageTransitionSheet
          visible
          pendingTransition={pendingTransition}
          userId={currentUserId}
          onDismiss={advanceQueue}
        />
      )}
    </>
  );
}
